export const divisions = [
  "Business Development Manager",
  "Customer Services Representative",
  "Marketing",
  "Reporting",
  "Operations",
  "Administration",
  "CSR Support",
  "Email Specialist",
  "System Development",
  "Cost Consultant",
  "Inspector",
  "Human Resources",
  "Accounts",
  "Other",
];
